import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { UpdateUsersAction } from '../../actions/users/update-users-action';
import { GetUsersAction } from '../../actions/users/get-users-action';
import { UpdateUsersErrorAction } from '../../actions/users/update-users-error-action';
import { Role } from '../../../models/role';
import { from, of } from 'rxjs';
import { GetCurrentUserAction } from '../../actions/current-user/get-current-user-action';

@Injectable()
export class UpdateUsersEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateUsers = createEffect(() => this.actions
    .pipe(
      ofType(UpdateUsersAction.type),
      mergeMap(action => {
        const updateUsersAction = <UpdateUsersAction>action;
        const promises = [];
        for (let role of [Role.Organisator, Role.Ceremoniemeester]) {
          const users = updateUsersAction.users.filter(u => u.role === role);
          if (users.length > 0) {
            promises.push(this.api.updateUsers(users, role));
          }
        }
        return from(Promise.all(promises))
          .pipe(
            mergeMap(_ => {
              return of(new GetUsersAction(updateUsersAction.bijbEvent), new GetCurrentUserAction(updateUsersAction.bijbEvent));
            }),
            catchError(e => {
              return of(new UpdateUsersErrorAction(e));
            })
          );

      })
    ));
}
